import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const addCreateQuestionStatusSelector = (state: State) =>
  state.createQuestion.status;
export const addCreateQuestionIdSelector = (state: State) =>
  state.createQuestion.entities;
export const addCreateQuestionLoadedSelector = isLoaded(
  addCreateQuestionStatusSelector,
);
export const shouldLoadaddCreateQuestionSelector = shouldLoad(
  addCreateQuestionStatusSelector,
);
export const addCreateQuestionRejectedSelector = isRejected(
  addCreateQuestionStatusSelector,
);
export const addCreateQuestionPendingSelector = isPending(
  addCreateQuestionStatusSelector,
);
